import React from 'react';
import { Typography, Grid } from '@material-ui/core';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { WithStyles } from '@material-ui/core/styles/withStyles';
import { OrderToShip } from 'src/shippingPlanning/ShippingPlanningService';
import { formatDate } from 'src/utils/formatters';

interface Props extends WithStyles<typeof styles> {
    order: OrderToShip;
    cartageShippingDate: string;
}

const styles = (): ReturnType<typeof createStyles> =>
    createStyles({
        receiptContainer: {
            padding: '20px',
            marginBottom: '30px',
            border: '1px solid #000',
            pageBreakAfter: 'always',
            '&:last-child': {
                pageBreakAfter: 'avoid'
            }
        },
        title: {
            fontWeight: 'bold',
            textAlign: 'center',
            marginBottom: '20px'
        },
        companyInfo: {
            textAlign: 'center',
            marginBottom: '30px',
            fontSize: '14px'
        },
        paragraph: {
            marginBottom: '15px',
            lineHeight: '1.6',
            textAlign: 'justify'
        },
        signatureSection: {
            marginTop: '30px'
        },
        signatureLine: {
            borderBottom: '1px solid #000',
            minHeight: '30px',
            marginTop: '10px'
        },
        fieldLabel: {
            fontWeight: 'bold',
            marginTop: '20px'
        }
    });

class OrderConfirmationReceiptBase extends React.Component<Props> {
    renderReceipt = (copyNumber: number): JSX.Element => {
        const { order, classes, cartageShippingDate } = this.props;
        const customerName = order.customer.delivery.name;
        const orderNumber = order.orderNumber;

        return (
            <div
                key={copyNumber}
                className={`print ${classes.receiptContainer}`}
            >
                <div className={classes.companyInfo}>
                    <Typography variant="body2">
                        <strong>WILSONDO s. r. o.</strong>
                    </Typography>
                    <Typography variant="body2">
                        Zemianska dedina 75, 02743 Nižná
                    </Typography>
                    <Typography variant="body2">
                        IČO: 47 429 151, IČ DPH: SK 2023887008
                    </Typography>
                </div>

                <Typography
                    style={{ marginTop: '65px' }}
                    variant="h5"
                    className={classes.title}
                >
                    Potvrdenie o prevzatí objednávky
                </Typography>

                <Typography className={classes.paragraph}>
                    Týmto potvrdzujem, že som riadne prevzal/a objednávku
                    obsahujúcu tovar, ktorý bol predmetom mojej žiadosti o
                    splátkový predaj prostredníctvom spoločnosti Quatro.
                </Typography>

                <Typography className={classes.paragraph}>
                    Svojím podpisom zároveň potvrdzujem, že všetok prevzatý
                    tovar je v súlade s objednávkou a neobsahuje žiadne
                    viditeľné poškodenia. Som si vedomý/á, že prevzatím
                    objednávky preberám plnú zodpovednosť za splnenie finančných
                    záväzkov voči spoločnosti Quatro podľa schválených podmienok
                    splátkového kalendára.
                </Typography>

                <Typography className={classes.paragraph}>
                    V prípade akýchkoľvek nezrovnalostí alebo otázok súvisiacich
                    s objednávkou som povinný/á bezodkladne kontaktovať
                    spoločnosť, od ktorej som objednávku obdržal/a.
                </Typography>

                <div className={classes.signatureSection}>
                    <Typography className={classes.fieldLabel}>
                        Meno a priezvisko zákazníka:{' '}
                        <strong>{customerName}</strong>
                    </Typography>

                    <Typography className={classes.fieldLabel}>
                        Číslo objednávky: <strong>{orderNumber}</strong>
                    </Typography>

                    <Grid container spacing={4} style={{ marginTop: '30px' }}>
                        <Grid item xs={6}>
                            <Typography>
                                Dátum: {formatDate(cartageShippingDate)}
                            </Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography>Podpis zákazníka:</Typography>
                            <div className={classes.signatureLine} />
                        </Grid>
                    </Grid>
                </div>
                <div className="page-break-after" />
            </div>
        );
    };

    render(): JSX.Element | null {
        const { order } = this.props;

        if (!order) {
            return null;
        }

        return (
            <>
                {this.renderReceipt(1)}
                {this.renderReceipt(2)}
            </>
        );
    }
}

const OrderConfirmationReceipt = withStyles(styles)(
    OrderConfirmationReceiptBase
);

export { OrderConfirmationReceipt };
